export enum TicketStatus {
  NEW,
  OPEN,
  SOLVED = 3,
  CLOSED,
  UNPICKED,
  PREMATURE,
  AUTOMATION,
}
